module.exports = __webpack_public_path__ + "54da128f8eab2efa32a4a6a85ba1af69.pdf";